import { useState, useEffect } from 'react';

export default function InstallPromptModal() {
  const [show, setShow] = useState(false);
  const [platform, setPlatform] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (sessionStorage.getItem('installPromptShown')) return;
      if (window.matchMedia('(display-mode: standalone)').matches) return;

      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      const isAndroid = /Android/.test(navigator.userAgent);

      if (isIOS) {
        setPlatform('ios');
        setShow(true);
      } else if (isAndroid) {
        setPlatform('android');
        setShow(true);
      }
      sessionStorage.setItem('installPromptShown', 'true');
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className="blurred-app-state">
      <div className="modal-card install-prompt-card">
        <button className="sidebar-close-btn" onClick={() => setShow(false)}>&times;</button>
        <h2>Get the Full Experience</h2>
        <p className="promo-text">For easy access, add this app to your home screen!</p>
        {platform === 'ios' && (
          <div className="install-instructions">
            <p>1. Tap the <strong>Share</strong> icon in your browser.</p>
            <p>2. Scroll down and tap <strong>'Add to Home Screen'</strong>.</p>
          </div>
        )}
        {platform === 'android' && (
          <div className="install-instructions">
            <p>Tap the <strong>'Add to Home Screen'</strong> button when prompted by your browser, or find it in the browser menu.</p>
          </div>
        )}
      </div>
    </div>
  );
}
